import React from 'react'
import { Spinner } from 'lib/ui/components/Spinner'
import { StyledButton, ButtonContent, LeftAdHoc } from './components/Styled'

const SKIN = {
  REGULAR: 'regular',
  OUTLINE: 'outline',
  TEXT: 'text'
}

interface Props {
  id: string
  className?: string
  children: React.ReactElement
  leftAdHoc?: React.ReactElement
  onClick: (e: any) => void
  isDisabled: boolean
  isLoading: boolean
  skin?: 'regular' | 'outline' | 'text'
  type?: 'button' | 'submit'
  dataSubmitButton?: boolean
  isVisible: boolean
}

export const PlaceOrderButton: React.FC<Props> = ({
  id,
  className,
  children,
  leftAdHoc,
  onClick,
  isDisabled = false,
  isLoading = false,
  skin = SKIN.REGULAR,
  type = 'button',
  dataSubmitButton,
  isVisible
}) => {
  return (
    <StyledButton
      type={type}
      id={id}
      className={className}
      skin={skin}
      onClick={onClick}
      isLoading={isLoading}
      disabled={isDisabled || isLoading}
      hasLeftAdHoc={!!leftAdHoc}
      data-submit-btn={dataSubmitButton}
      style={{ display: isVisible ? 'block' : 'none' }}
    >
      {leftAdHoc && <LeftAdHoc>{leftAdHoc}</LeftAdHoc>}

      <ButtonContent>{children}</ButtonContent>

      {isLoading && <Spinner size={18} />}
    </StyledButton>
  )
}
